import React, { useEffect, useRef, useState } from 'react'
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import '../../DataTableDemo.css';
import { InputNumber } from 'primereact/inputnumber';
import apis from '../../api';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './Licenses.css'
import Maps from '../Maps/Maps';
import { Carousel } from 'primereact/carousel';
import fileToBase64 from '../../services/fileToBase64';
import { FileUpload } from 'primereact/fileupload';
import useWindowDimensions from '../hooks/useDimensions';
import Webcam from 'react-webcam';
import Maps2 from '../Maps/Maps2';
import { Badge } from 'primereact/badge';
import { Checkbox } from 'primereact/checkbox';
import { Message } from 'primereact/message';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Galleria } from 'primereact/galleria';
import axios from 'axios';
import { TablePaginator } from '../TablePaginator/TablePaginator';
import useUserIP from '../../helpers/useUserIP';

const Licenses = () => {

  const [idSolicitud, setIdSolicitud] = useState("")
  const [tipo, setTipo] = useState("")
  const [consolidado, setConsolidado] = useState("")
  const [diasTiempo, setDiasTiempo] = useState("")
  const [diasDinero, setDiasDinero] = useState("")
  const [fechaInicio, setFechaInicio] = useState("")
  const [fechaFin, setFechaFin] = useState("")
  const [files, setFiles] = useState([])

  const [fechaInicioAusentismo, setFechaInicioAusentismo] = useState("")
  const [fechaFinAusentismo, setFechaFinAusentismo] = useState("")
  const [contingencia, setContingencia] = useState("")
  const [tiempo, setTiempo] = useState("")
  const [observaciones, setObservaciones] = useState("")
  const [adjunto, setAdjunto] = useState("")
  const [ciudad, setCiudad] = useState("")
  const [pais, setPais] = useState("")

  const [longitud, setLongitud] = useState(0)
  const [latitud, setLatitud] = useState(0)
  const [trackFotos, setTrackFotos] = useState([])
  const [trackDescription, setTrackDescription] = useState([])
  const [trackInfo, setTrackInfo] = useState({})

  const [listaTipo, setListaTipo] = useState([])
  const [listaContingencia, setListaContingencia] = useState([])

  const [loading1, setLoading1] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [loading3, setLoading3] = useState(false)
  const [loading4, setLoading4] = useState(false)
  const [loading5, setLoading5] = useState(false)
  const [loading6, setLoading6] = useState(false)
  const [loadPage, setLoadPage] = useState(false)

  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenDelete, setIsOpenDelete] = React.useState(false);

  const [isOpenA, setIsOpenA] = React.useState(false);

  const [isOpenT, setIsOpenT] = React.useState(false);

  const [isOpenOptions, setIsOpenOptions] = React.useState(false);

  const [isOpenD, setIsOpenD] = useState(false)

  const [trackingType, setTrackingType] = useState('')

  const [isOpenMapa, setIsOpenMapa] = useState(false)

  const [captured, setCaptured] = useState(false)
  const [loadCaptured, setLoadCaptured] = useState(false)
  const [tries, setTries] = useState(0)
  const [manual, setManual] = useState(false)

  const [dialingData, setDialingData] = useState({
    IMAGE: '',
    IMAGE64: '',
    DATE: '',
    TIME: '',
    PIN: localStorage.getItem("pin"),
    NAME: '',
    CONTRACT_ID: ''
  });

  const toast = useRef(null);
  const labelStyle = {
    display: "block",
    float: "left",
    marginTop: "5px",
    width: "100%",
    paddingTop: "5px"
  }
  const headers = {
    authorization: localStorage.getItem('token')
  }
  
  const fileUploadRef = useRef(null);
  
  const { width, height } = useWindowDimensions()
  const elementWidth = { width: width > 768 ? "20rem" : '100%' }

  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const [retry, setRetry] = useState(false)

  const [inChecked, setInChecked] = useState(false)
  const [outChecked, setOutChecked] = useState(false)

  const ip = useUserIP();

  const containerStyles = {
    display: 'block',
    maxWidth: '200px',
    // maxHeight: '200px',
    width: 'auto',
    height: 'auto'
  };

  const imgStyles = {
    width: '100%',
    height: '100%',
  };

  const isMobile = width <= 768;
  const isTablet = width > 768 && width < 1024;

  const videoConstraints = isMobile
    ? {
        facingMode: "user",
        aspectRatio: 16 / 9,
        // no width/height — let the browser use the camera's native resolution
      }
    : {
        facingMode: "user",
        aspectRatio: 16 / 9,
        width:  { ideal: 1280 },
        height: { ideal: 720  },
      };
  
  const responsiveOptions = [
    {
      breakpoint: '991px',
      numVisible: 4
    },
    {
      breakpoint: '767px',
      numVisible: 3
    },
    {
      breakpoint: '575px',
      numVisible: 1
    }
  ];

  const upscaleImage = (base64Image, scaleFactor = 2) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width  = img.width  * scaleFactor;
        canvas.height = img.height * scaleFactor;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.9));
      };
      img.src = base64Image;
    });
  };

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  useEffect(() => {
    getReqLists()
  }, [])

  useEffect(() => {
    setTabla()
  }, [])

  useEffect(() => {
    handleLocation()
  }, [])

  const showModal = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    hideModalOptions()
    limpiar();
  };

  const showModalDelete = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpenDelete(true);
    console.log(consolidado)
  };

  const hideModalDelete = () => {
    setIsOpenDelete(false);
    limpiar();
  };

  const showModalA = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpenA(true);
  };

  const hideModalA = () => {
    setIsOpenA(false);
    hideModalOptions()
    limpiar();
  };

  const showModalT = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    console.log(dialingData)
    setIsOpenT(true);
  };

  const hideModalT = () => {
    setIsOpenT(false);
    hideModalOptions()
    setManual(false)
    setInChecked(false)
    setOutChecked(false)
    setTrackingType('')
    setDialingData({
      ...dialingData,
      IMAGE: "",
      IMAGE64: ""
    })
    setLatitud('')
    setLongitud('')
    setInChecked(false)
    setOutChecked(false)
    limpiar();
    console.log(dialingData)
  };

  const showModalOptions = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpenOptions(true);
  };

  const hideModalOptions = () => {
    setIsOpenOptions(false);
    limpiar();
  };

  const selectModal = (tipo) => {
    if (tipo.detail_id === 'VAC') {
      showModal();
      hideModalOptions()
    }
    else if (tipo.detail_id === 'ABS') {
      showModalA();
      hideModalOptions()
    }
    else if (tipo.detail_id === 'TRK') {
      console.log(tipo)
      showModalT();
      hideModalOptions()
    }

  }

  const showModalD = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpenD(true);
  };

  const hideModalD = () => {
    setIsOpenD(false);
    limpiar();
  };

  const showModalMapa = () => {
    // if (!listasCargadas) {
    //   setListas()
    // }
    setIsOpenMapa(true);
  };

  const hideModalMapa = () => {
    setIsOpenMapa()
  };


  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = TablePaginator()

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className='flex flex-row'>
        <Button icon="pi pi-align-justify" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => { initializeData(rowData); getRequestDetail(rowData.REQUESTS_ID) }} tooltip="Detalle" />
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" onClick={() => { initializeData(rowData); showModalDelete() }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="barra3">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm w-full" />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'REQUESTS_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NOVELTY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTRACT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'UNITY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TIME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  function handleLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error);
    } else {
      console.log("Geolocation not supported");
    }
  }

  async function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    setLatitud(latitude);
    setLongitud(longitude);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GEO}`;

    try {
      const response = await axios.get(url);
      const results = response.data.results;

      if (results.length > 0) {
        const addressComponents = results[0].address_components;
        const countryComponent = addressComponents.find(component =>
          component.types.includes('country')
        );
        const cityComponent = addressComponents.find(component =>
          component.types.includes('locality') || component.types.includes('administrative_area_level_2')
        );
        console.log(countryComponent)
        console.log(cityComponent)
        if (countryComponent) {
          setPais(countryComponent.long_name);
        }
        if (cityComponent) {
          setCiudad(cityComponent.long_name)
        }
      }
    } catch (error) {
      console.error('Error fetching the country name:', error);
    }
    console.log(position)

  }

  function error() {
    console.log("No se puede obtener la localizacion");
  }

  async function limpiar() {
    // setConsolidado("");
    setDiasTiempo("");
    setDiasDinero("");
    setFechaInicio("");
    setFechaFin("");
    setFechaInicioAusentismo("");
    setFechaFinAusentismo("");
    setContingencia("");
    setTiempo("");
    setObservaciones("");
    setTipo("")
    setAdjunto("")
    setDialingData({
      ...dialingData,
      DATE: '',
      TIME: '',
      // PIN: '',
      NAME: '',
      CONTRACT_ID: '',
      IMAGE: ''
    });
    setCaptured(false)
    setLoadCaptured(false)
  }

  async function initializeData(row) {
    setIdSolicitud(row.REQUESTS_ID)
    setTipo(row.NOVELTY_ID)
  }

  const getReqLists = async () => {
    try {
      await apis.getRequestListAdd(localStorage.getItem('entity'), localStorage.getItem('client'), localStorage.getItem('contract_id'), "WEB", headers).then(res => {
        let tipos = res.data.TYPE_NOVELTIES
        let contingencias = res.data.CONTINGENCY
        let _consolidado = res.data.DAY_CSO
        setListaTipo(tipos)
        setListaContingencia(contingencias)
        setConsolidado(_consolidado)
      })
    }
    catch (err) {
      console.log(err)
    }
  }

  const getRequestDetail = async (id) => {
    const _entity = localStorage.getItem('entity')
    const _client = localStorage.getItem('client')

    try {
      await apis.getRequest(_entity, _client, id, headers).then(res => {
        let solicitud = res.data
        let tipo = solicitud.NOVELTY.split("|")
        if (tipo[0] === "VAC") {
          // setConsolidado(solicitud.DAY_CSO)
          setDiasDinero(solicitud.DAYS_DIN)
          setDiasTiempo(solicitud.DAYS_TIE)
          setFechaInicio(invDateFormat(solicitud.START_DATE))
          setFechaFin(invDateFormat(solicitud.END_DATE))
          if (solicitud.FILES && solicitud.FILES.length > 0) {
            let adjuntos = solicitud.FILES[0]
            setAdjunto(adjuntos)
          }
        }
        else if (tipo[0] === "ABS") {
          let _contingencia = solicitud.CONTINGENCY.split("|")
          setFechaInicioAusentismo(invDateFormat(solicitud.START_DATE))
          setFechaFinAusentismo(invDateFormat(solicitud.END_DATE))
          setContingencia({ CODE: _contingencia[0], TYPE: _contingencia[0], NAME: _contingencia[1] })
          setTiempo(solicitud.DAYS)
          setObservaciones(solicitud.OBSERVATIONS)
          if (solicitud.FILES && solicitud.FILES.length > 0) {
            let adjuntos = solicitud.FILES[0]
            setAdjunto(adjuntos)
          }
        }
        else if (tipo[0] === "TRK") {
          console.log(solicitud)
          let location = solicitud.GEOLOCATION
          let imagenes = {
            ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
            DETAIL: solicitud.FILES ? solicitud.FILES : []
          }
          let info = {
            DATE: solicitud.DATE ? solicitud.DATE : "",
            TIME: solicitud.TIME ? solicitud.TIME : "",
            TYPE: solicitud.TYPE ? solicitud.TYPE : "",
            STATUS: solicitud.STATUS ? solicitud.STATUS : "",
            NUMBER_ID: solicitud.NUMBER_ID
          }
          console.log(imagenes)
          setLongitud(parseFloat(location.LON))
          setLatitud(parseFloat(location.LAT))
          setTrackDescription(solicitud.CONTRACT_ID)
          setTrackFotos(imagenes)
          setTrackInfo({
            ...trackInfo,
            ...info
          })
        }
        else if (tipo[0] === "TURN") {
          let location = solicitud.GEOLOCATION
          location[0]["LAT"] = parseFloat(location[0]["LAT"])
          location[0]["LON"] = parseFloat(location[0]["LON"])
          location[1]["LAT"] = parseFloat(location[1]["LAT"])
          location[1]["LON"] = parseFloat(location[1]["LON"])
          let imagenes = {
            ICON: solicitud.IMAGES ? solicitud.IMAGES : "",
            DETAIL: solicitud.FILES ? solicitud.FILES : []
          }
          let info = {
            DATE_IN: solicitud.DATE_IN ? solicitud.DATE_IN : "",
            DATE_OUT: solicitud.DATE_OUT ? solicitud.DATE_OUT : "",
            TIME_IN: solicitud.TIME_IN ? solicitud.TIME_IN : "",
            TIME_OUT: solicitud.TIME_OUT ? solicitud.TIME_OUT : "",
            STATUS: solicitud.STATUS ? solicitud.STATUS : "",
            NUMBER_ID: solicitud.NUMBER_ID
          }
          setLongitud([location[0]['LON'], location[1]['LON']])
          setLatitud([location[0]['LAT'], location[1]['LAT']])
          setTrackDescription(solicitud.CONTRACT_ID)
          setTrackFotos([imagenes, imagenes])
          setTrackInfo({
            ...trackInfo,
            ...info
          })
        }
      })
      showModalD()
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const setTabla = async () => {
    const _entity = localStorage.getItem('entity')
    const _client = localStorage.getItem('client')
    const _contract = localStorage.getItem('contract_id')
    const _estado = "PDTE"
    const _fechaInicio = "NULL"
    const _fechaFin = "NULL"

    try {
      await apis.getAllRequests(_entity, _client, _estado, _contract, _fechaInicio, _fechaFin, headers).then(res => {
        if (res.data.NOVELTIES.length > 0) {
          let data = res.data.NOVELTIES
          let solicitudes = []
          data.forEach(element => {
            let registro = element
            // let _consolidado = registro.DAY_CSO
            // setConsolidado(_consolidado)
            let solicitud = registro.NOVELTY.split("|")
            let contrato = registro.CONTRACT_ID.split("|")
            let estado = registro.STATUS.split("|")
            let idSolicitud = solicitud[0]
            let idContrato = contrato[0]
            let idEstado = estado[0]
            solicitud = solicitud[1]
            contrato = contrato[1]
            estado = estado[1]
            registro.NOVELTY = solicitud
            registro.CONTRACT_ID = idContrato
            registro.STATUS = estado
            registro = {
              ...registro,
              NOVELTY_ID: idSolicitud,
              CONTRACT: contrato,
              STATUS_ID: idEstado
            }
            solicitudes.push(registro)
          });
          setRows(solicitudes)
          setLoadPage(true)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Consulta exitosa" })
        }
        else {
          setRows([])
          setLoadPage(true)
          toast.current.show({ severity: 'warn', summary: 'Éxito', detail: "Consulta sin resultados" })
        }
      })
    }
    catch (err) {
      setRows([])
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const postRequestVac = async () => {
    const _entity = localStorage.getItem('entity')
    const _client = localStorage.getItem('client')
    const _contract = localStorage.getItem('contract_id')
    const _diasTiempo = diasTiempo
    const _diasDinero = diasDinero
    const _fechaInicio = dateFormat(fechaInicio)
    const _fechaFin = dateFormat(fechaFin)
    let archivos = []

    if (files.length > 0) {
      let _archivo = files[0]
      let nombre = _archivo.name
      let base64 = ""

      await fileToBase64(_archivo).then(res => {
        base64 = res
      })

      archivos.push({
        name: nombre,
        source: base64
      })
    }

    let date = (new Date(Date.now())).toLocaleString('es-CO').toString()
    console.log(date)
    let newDate = ""
    for (let i = 0; i < date.length; i++) {
        if (date.charCodeAt(i) <= 127) {
            newDate += date.charAt(i);
        }
    }

    const document = {
      "/Pais": pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      "/Ciudad": ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      "/Usuario": localStorage.getItem('name'),
      "/Aplicacion": "Remuner BPO",
      "/Responsable": "Remuner",
      "/Fecha": newDate,  
      "/IP": ip ? ip : "",
      "/Identification": localStorage.getItem('number_id'),
      "/Correo": localStorage.getItem('user'),
    }

    console.log(document)

    const vacation = {
      ENTITY: _entity,
      CLIENT: _client,
      START_DATE: _fechaInicio,
      END_DATE: _fechaFin,
      DAYS_TIE: _diasTiempo,
      DAYS_DIN: _diasDinero,
      CONTRACT_ID: _contract,
      NOVELTY: "VAC",
      files: archivos,
      DOCUMENT: document
    }

    try {
      await apis.postRequest(vacation, headers).then(res => {
        setLoading1(false)
        setTabla()
        getReqLists()
        hideModal()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Solicitud de vacación agregada exitosamente' });
      })
    }
    catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const postRequestAbs = async () => {

    const _entity = localStorage.getItem('entity')
    const _client = localStorage.getItem('client')
    const _contract = localStorage.getItem('contract_id')
    const _tiempo = tiempo
    const _fechaInicioAusentismo = dateFormat(fechaInicioAusentismo)
    const _fechaFinAusentismo = dateFormat(fechaFinAusentismo)
    const _contingencia = contingencia.CODE
    const _observaciones = observaciones
    let archivos = []

    if (files.length > 0) {
      let _archivo = files[0]
      let nombre = _archivo.name
      let base64 = ""

      await fileToBase64(_archivo).then(res => {
        base64 = res
      })

      archivos.push({
        name: nombre,
        source: base64
      })
    }

    let date = (new Date(Date.now())).toLocaleString('es-CO').toString()
    console.log(date)
    let newDate = ""
    for (let i = 0; i < date.length; i++) {
        if (date.charCodeAt(i) <= 127) {
            newDate += date.charAt(i);
        }
    }

    const document = {
      "/Pais": pais.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      "/Ciudad": ciudad.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
      "/Usuario": localStorage.getItem('name'),
      "/Aplicacion": "Remuner BPO",
      "/Responsable": "Remuner",
      "/Fecha": newDate,  
      "/IP": ip ? ip : "",
      "/Identification": localStorage.getItem('number_id'),
      "/Correo": localStorage.getItem('user'),
    }

    console.log(document)

    const vacation = {
      ENTITY: _entity,
      CLIENT: _client,
      START_DATE: _fechaInicioAusentismo,
      END_DATE: _fechaFinAusentismo,
      DAYS: _tiempo,
      CONTRACT_ID: _contract,
      NOVELTY: "ABS",
      CONTINGENCY: _contingencia,
      OBSERVATIONS: _observaciones,
      files: archivos,
      DOCUMENT: document
    }

    try {
      await apis.postRequest(vacation, headers).then(res => {
        setLoading4(false)
        setTabla()
        getReqLists()
        hideModalA()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Solicitud de ausentismo agregada exitosamente' });
      })
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const deleteRequest = async () => {
    const _idSolicitud = idSolicitud
    const _entity = localStorage.getItem('entity')
    const _cliente = localStorage.getItem('client')
    try {
      await apis.deleteRequest(_entity, _cliente, _idSolicitud, headers).then(res => {
        setLoading3(false)
        setTabla()
        getReqLists()
        hideModalDelete()
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Solicitud eliminada exitosamente' });
      })
    }
    catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const facialRecognition = async (image) => {
    setRetry(false)
    let dateTime = getDateTime(new Date());
    let newImage = image.split(',')[1]
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      IMAGE: newImage,
      TOKEN: localStorage.getItem('token'),
      CONTRACT_ID: localStorage.getItem('contract_id')
    }

    try {
      await apis.postImageRecognition(payload, headers).then(res => {
        handleLocation()
        let data = res.data
        setDialingData({
          ...dialingData,
          IMAGE: image,
          CONTRACT_ID: data.CONTRACT_ID,
          NAME: data.NAME,
          DATE: dateTime.DATE,
          TIME: dateTime.TIME
          // PIN: data.PIN
        })
        setTries(0)
      })
    }
    catch (err) {
      console.log(err)
      setDialingData({
        ...dialingData,
        DATE: dateTime.DATE,
        TIME: dateTime.TIME
      })
      if (tries == 3) {
        setTries(0)
      }
      else {
        setTries(tries + 1)
      }
    }
  }

  const getDateTime = (date) => {
    let day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate().toString()
    let month = Number(date.getMonth() + 1) > 9 ? Number(date.getMonth() + 1).toString() : '0' + Number(date.getMonth() + 1).toString()
    let dateString = day + '-' + month + '-' + date.getFullYear();
    let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
    let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
    let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
    let hourString = hours + ':' + minutes + ':' + seconds;

    return {
      DATE: dateString,
      TIME: hourString
    };
  }

  const postTrackingNovelty = async () => {
    setLoadCaptured(true)
    const payload = {
      ...dialingData,
      GEOLOCATION: {
        LAT: latitud,
        LON: longitud
      },
      IMAGE: dialingData.IMAGE.split(',')[1],
      INPUT: trackingType,
      TOKEN: localStorage.getItem('token'),
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      CONTRACT_ID: dialingData.CONTRACT_ID ? dialingData.CONTRACT_ID : localStorage.getItem('contract_id'),
      IMAGE64: dialingData.IMAGE64 ? dialingData.IMAGE64 : "",
      SOURCE: 'SELF',
      METHOD: 'AUT',
    }
    try {
      await apis.postTrackingNovelty(payload, headers).then(res => {
        let dateTime = res.data.DATE.split(" ");
        setDialingData({
          ...dialingData,
          DATE: dateTime[0],
          TIME: dateTime[1]
        })
        setCaptured(true)
        setLoadCaptured(false)
        setTabla()
        setManual(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Novedad creada exitosamente' });
      })
    }
    catch (err) {
      setLoadCaptured(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message, sticky: true });
    }
  }

  const handleChangeFechaFinVac = async (fecha) => {
    setFechaInicio(fecha)
    const _entity = localStorage.getItem('entity')
    const _cliente = localStorage.getItem('client')
    const _contract_id = localStorage.getItem('contract_id')
    const _date_ini = dateFormat(fecha);
    const _day_time = diasTiempo;
    if (_date_ini && _day_time !== "" && _day_time > 0) {
      apis.getVacationEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setFechaFin(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
    else {
      setFechaFin("")
    }
  }

  const handleChangeDiasVac = async (dias) => {
    setDiasTiempo(dias)
    const _entity = localStorage.getItem('entity')
    const _cliente = localStorage.getItem('client')
    const _contract_id = localStorage.getItem('contract_id')
    const _date_ini = dateFormat(fechaInicio);
    const _day_time = dias;
    if (_date_ini && _day_time !== "" && _day_time > 0) {
      apis.getVacationEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setFechaFin(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
    else {
      setFechaFin("")
    }
  }

  const handleChangeFechaFincAbs = async (fecha) => {
    setFechaInicioAusentismo(fecha)
    const _entity = localStorage.getItem('entity')
    const _cliente = localStorage.getItem('client')
    const _contract_id = localStorage.getItem('contract_id')
    const _date_ini = dateFormat(fecha);
    const _day_time = tiempo;
    if (_date_ini && _day_time !== "" && _day_time > 0) {
      apis.getLicenseEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setFechaFinAusentismo(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
    else {
      setFechaFinAusentismo("")
    }
  }

  const handleChangeDiasAbs = async (dias) => {
    setTiempo(dias)
    const _entity = localStorage.getItem('entity')
    const _cliente = localStorage.getItem('client')
    const _contract_id = localStorage.getItem('contract_id')
    const _date_ini = dateFormat(fechaInicioAusentismo);
    const _day_time = dias;
    if (_date_ini && _day_time !== "" && _day_time > 0) {
      apis.getLicenseEndDate(_entity, _cliente, _date_ini, _day_time, _contract_id, headers).then(res => {
        setFechaFinAusentismo(invDateFormat(res.data.END_DATE))
      }).catch(err => {
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
    else {
      setFechaFinAusentismo("")
    }
  }

  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={() => { setLoading1(true); postRequestVac() }}
        loading={loading1} label='Guardar'
        disabled={(!diasTiempo && !diasDinero) || !fechaInicio}
      ></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar solicitud vacaciones</h3>
    </div>
  );


  const deleteFooter = (
    <div>
      <Button onClick={hideModalDelete}>Cancelar</Button>
      <Button onClick={() => { setLoading3(true); deleteRequest() }} loading={loading3} label='Eliminar'></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>Eliminar solicitud</h3>
    </div>
  );

  const addFooterA = (
    <div>
      <Button onClick={hideModalA}>Cancelar</Button>
      <Button onClick={() => { setLoading4(true); postRequestAbs() }}
        loading={loading4} label='Guardar'
        disabled={!contingencia || !fechaInicioAusentismo || !fechaFinAusentismo || !tiempo}
      ></Button>
    </div>
  );

  const addHeaderA = (
    <div>
      <h3>Agregar solicitud ausentismo </h3>
    </div>
  );

  const addFooterT = (
    <div>
      {(dialingData.IMAGE || manual) && !captured &&
        <div className='flex flex-row gap-1 flex-wrap'>
          <Button onClick={hideModalT} label='Cancelar' />
          {!manual && <Button onClick={() => setRetry(true)} label='Reintentar' />}
          <Button label='Aceptar' loading={loadCaptured} onClick={() => { postTrackingNovelty() }} />
        </div>}
    </div>
  );

  const addHeaderT = (
    <div>
      <h3>Agregar novedad</h3>
    </div>
  );

  const optionsHeader = (
    <div>
      <h3>Seleccione tipo de solicitud </h3>
    </div>
  );

  const optionsFooter = (
    <div>
      <Button onClick={hideModalOptions}>Cancelar</Button>
    </div>
  );

  const detailHeader = (
    <div>
      <h3>Detalle solicitud</h3>
    </div>
  );

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModalOptions} />
      </React.Fragment>
    )
  }

  const itemTemplate = (item) => {
    return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ width: '100%', display: 'block', maxHeight: '50vh', 
      height: 'auto', objectFit: 'contain', display: 'block' }} />;
  }

  const thumbnailTemplate = (item) => {
    return <img src={item.URL ? item.URL : item} alt={item.NAME_FILE ? item.NAME_FILE : 'photo'} style={{ display: 'block', maxHeight: "100px", maxWidth: "150px" }} />;
  }

  const header = <div className='flex justify-content-center mt-2'>
    <h4>Entrada y salida de la novedad</h4>
  </div>

  const buttonStyle = {
    overflow: "hidden",
    maxWidth: '20rem'
  }

  return (
    <div className='surface-100 px-4 py-5 md:px-6 lg:px-8'>
      <Toast ref={toast} />
      <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
        <span className="text-900">Mis novedades</span>
      </div>
      <Dialog header={optionsHeader} footer={optionsFooter} visible={isOpenOptions} position="top" style={{ width: width > 768 ? "26rem" : '90vw' }} draggable={false} resizable={false} modal onHide={hideModalOptions}>
        <label style={labelStyle} htmlFor="label">Tipo solicitud</label>
        <Dropdown style={elementWidth} value={tipo} autofocus optionLabel='description'
          filter showClear filterBy="description" emptyMessage={"No hay tipos disponibles"}
          onChange={(e) => { setTipo(e.value); selectModal(e.value) }} options={listaTipo} placeholder={tipo ? tipo.description : 'Seleccione'} />
      </Dialog>
      <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: width > 768 ? "26rem" : '90vw' }} draggable={false} resizable={false} modal onHide={hideModal}>
        <label style={labelStyle} htmlFor="label">Dias consolidado</label>
        <InputNumber min={0} value={consolidado} placeholder="Dias tiempo" disabled={true} />
        <label style={labelStyle} htmlFor="label">Dias tiempo</label>
        <InputNumber min={0} value={diasTiempo} onChange={(e) => handleChangeDiasVac(e.value)} placeholder="Dias tiempo" />
        <label style={labelStyle} htmlFor="label">Dias Dinero</label>
        <InputNumber min={0} value={diasDinero} onChange={(e) => setDiasDinero(e.value)} placeholder="Dias Dinero" />
        <label style={labelStyle} htmlFor="label">Fecha inicio</label>
        <Calendar style={elementWidth} id="navigators" value={fechaInicio} onChange={(e) => handleChangeFechaFinVac(e.value)} locale="es"
          dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
        />
        <label style={labelStyle} htmlFor="label">Fecha fin</label>
        <Calendar style={elementWidth} id="navigators" value={fechaFin} onChange={(e) => { setFechaFin(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" disabled={true} showIcon />
        <label style={labelStyle} htmlFor="label">Adjunto</label>
        <div className='flex flex-wrap align-items-center mt-6 gap-2'>
          <FileUpload
            mode="basic" name="demo[]" ref={fileUploadRef} accept="application/pdf" maxFileSize={2000000} chooseLabel="Seleccionar" onValidationFail={() => {
              toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
            }}
            onSelect={(e) => setFiles(e.files)} />
          <Message severity="info" text="Máx. 2 MB" />
        </div>
      </Dialog>
      <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenDelete} position="top" style={{ width: width > 768 ? "26rem" : '90vw' }} draggable={false} resizable={false} modal onHide={hideModalDelete} />

      <Dialog header={addHeaderA} footer={addFooterA} visible={isOpenA} position="top" style={{ width: width > 768 ? "26rem" : '90vw' }} draggable={false} resizable={false} modal onHide={hideModalA}>
        <label style={labelStyle} htmlFor="label">Fecha inicio</label>
        <Calendar style={elementWidth} id="navigators" value={fechaInicioAusentismo} onChange={(e) => handleChangeFechaFincAbs(e.value)} locale="es"
          dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
        />
        <label style={labelStyle} htmlFor="label">Fecha fin</label>
        <Calendar style={elementWidth} id="navigators" value={fechaFinAusentismo} onChange={(e) => setFechaFinAusentismo(e.value)} locale="es"
          dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
        />
        <label style={labelStyle} htmlFor="label">Contingencia</label>
        <Dropdown style={elementWidth} value={contingencia} autofocus optionLabel='NAME'
          filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
          onChange={(e) => { setContingencia(e.value) }} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
        <label style={labelStyle} htmlFor="label">Tiempo</label>
        <InputNumber min={0} value={tiempo} placeholder="Tiempo" onChange={(e) => handleChangeDiasAbs(e.value)} />
        <label style={labelStyle} htmlFor="label">Observaciones</label>
        <InputTextarea maxLength={70} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} rows={4} cols={30} style={elementWidth} />
        <label style={labelStyle} htmlFor="label">Adjunto{contingencia?.DOCUMENT === 'SI' ? '* (Obligatorio)' : ''}</label>
        <div className='flex flex-wrap align-items-center mt-6 gap-2'>
          <FileUpload
            mode="basic" name="demo[]" ref={fileUploadRef} accept="application/pdf" maxFileSize={2000000} chooseLabel="Seleccionar" onValidationFail={() => {
              toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Error al subir el archivo. Supera el tamaño máximo permitido (2 MB)', sticky: true });
            }}
            onSelect={(e) => setFiles(e.files)} />
          <Message severity="info" text="Máx. 2 MB" />
        </div>
      </Dialog>

      <Dialog header={addHeaderT} footer={addFooterT} visible={isOpenT} position="top" draggable={false}
        resizable={false} modal onHide={hideModalT} className='modal-trk'>
        {!captured && <div className='flex flex-row w-full justify-content-center'>
          <div className="flex align-items-center">
            <Badge className="ml-2 mr-1" value="Entrada" size="medium" severity="success" />
            <Checkbox inputId="IN" value="IN" className='check-in'
              onChange={(e) => {
                setInChecked(e.checked)
                if (outChecked) {
                  setOutChecked(false)
                }
                setTrackingType(e.value)
              }}
              checked={inChecked}
            />
          </div>
          <div className="flex align-items-center">
            <Badge className="ml-2 mr-1" value="Salida" size="medium" severity="danger" />
            <Checkbox inputId="OUT" value="OUT" className='check-out'
              onChange={(e) => {
                setOutChecked(e.checked)
                if (inChecked) {
                  setInChecked(false)
                }
                setTrackingType(e.value)
              }}
              checked={outChecked}
            />
          </div>
        </div>}
        &nbsp;
        {(!manual && !dialingData.IMAGE || retry) &&
          <div
            style={{
              width: isMobile ? "100%" : isTablet ? "380px" : "600px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Webcam
              audio={false}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              mirrored={false}
              style={{
                width: "100%",
                aspectRatio: isMobile ? "9/16" : "16/9",
                maxHeight: isMobile ? "55vh" : "50vh",  
                objectFit: "cover",
                display: "block",
                borderRadius: "4px",
              }}
            >
              {({ getScreenshot }) => (
                <Button
                  icon='pi pi-camera'
                  style={{ width: '100%' }}
                  tooltip='Tomar foto'
                  disabled={!inChecked && !outChecked}
                  onClick={async () => {
                    let imageSrc = isMobile
                      ? getScreenshot()   // use whatever the camera is natively giving
                      : getScreenshot({ width: 1280, height: 720 });
                    imageSrc = isMobile ? await upscaleImage(imageSrc, 4) : imageSrc
                    facialRecognition(imageSrc);
                  }}
                />
              )}
            </Webcam>
          </div>
          }
        {
          (manual || tries >= 3) &&
          <>
            <label>PIN</label>
            <InputText value={dialingData.PIN} disabled />
          </>
        }
        {dialingData.IMAGE && !retry && <>
          <div style={{ width: isMobile ? '100%' : '600px' }}>
            <img
              src={dialingData.IMAGE}
              alt='Tracking'
              style={{
                width: '100%',
                maxHeight: '50vh',      // never taller than 60% of the viewport
                aspectRatio: isMobile ? '9/16' : '16/9',
                height: "auto",
                objectFit: 'contain',   // changed: show the full image within the box
                display: 'block',
                borderRadius: '4px',
              }}
            />
          </div>
          <div className='flex flex-column gap-1'>
            <span>Contrato: {dialingData.CONTRACT_ID} | Nombre: {dialingData.NAME} | PIN:  {dialingData.PIN}</span>
            <span>Fecha: {dialingData.DATE} | Hora: {dialingData.TIME}</span>
            <span>LAT: {latitud} | LON: {longitud}</span>
          </div>
        </>
        }
      </Dialog>

      <Dialog header={detailHeader} visible={isOpenD} position="top" style={tipo !== "TRK" ? { width: "26rem" } : { width: width > 768 ? "70vw" : "95vw" , height: "90vh" }}
        draggable={false} resizable={false} modal onHide={hideModalD}>
        {tipo === "VAC" ? <><label style={labelStyle} htmlFor="label">Dias consolidado</label>
          <InputNumber min={0} value={consolidado} placeholder="Dias consolidado" disabled={true} />
          <label style={labelStyle} htmlFor="label">Dias tiempo</label>
          <InputNumber min={0} value={diasTiempo} placeholder="Dias tiempo" disabled={true} />
          <label style={labelStyle} htmlFor="label">Dias Dinero</label>
          <InputNumber min={0} value={diasDinero} placeholder="Dias Dinero" disabled={true} />
          <label style={labelStyle} htmlFor="label">Fecha inicio</label>
          <Calendar style={elementWidth} id="navigators" value={fechaInicio} locale="es"
            dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
          />
          <label style={labelStyle} htmlFor="label">Fecha fin</label>
          <Calendar style={elementWidth} id="navigators" value={fechaFin} locale="es" dateFormat="dd-mm-yy"
            yearRange="2010:2030" disabled={true} showIcon />
          {adjunto &&
            <>
              <label style={labelStyle} htmlFor="label">Adjunto</label>
              <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
            </>
          }
        </>
          : tipo === "ABS" ?
            <div className='flex flex-column'>
              <label style={labelStyle} htmlFor="label">Fecha inicio</label>
              <Calendar style={elementWidth} id="navigators" value={fechaInicioAusentismo} disabled={true} locale="es"
                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon
              />
              <label style={labelStyle} htmlFor="label">Fecha inicio</label>
              <Calendar style={elementWidth} id="navigators" value={fechaFinAusentismo} locale="es"
                dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon disabled={true}
              />
              <label style={labelStyle} htmlFor="label">Contingencia</label>
              <Dropdown style={elementWidth} value={contingencia} autofocus optionLabel='NAME'
                filter showClear filterBy="NAME" emptyMessage={"No hay tipos disponibles"}
                disabled={true} options={listaContingencia} placeholder={contingencia ? contingencia.NAME : 'Seleccione'} />
              <label style={labelStyle} htmlFor="label">Tiempo</label>
              <InputNumber min={0} value={tiempo} placeholder="Tiempo" disabled={true} />
              <label style={labelStyle} htmlFor="label">Observaciones</label>
              <InputTextarea maxLength={70} value={observaciones} disabled={true} rows={4} cols={30} style={elementWidth} />
              {adjunto &&
                <>
                  <label style={labelStyle} htmlFor="label">Adjunto</label>
                  <Button className='file-btn' style={buttonStyle} label={width > 426 ? adjunto.NAME_FILE + "." + adjunto.TYPE_FILE : ""} icon="pi pi-download"
                    onClick={() => window.location.href = adjunto.URL} tooltip={adjunto.NAME_FILE + "." + adjunto.TYPE_FILE} tooltipOptions={{ position: 'bottom' }} />
                </>
              }
            </div>
            : tipo === 'TRK' ?
              <>
                <Maps2 latitud={[latitud]} longitud={[longitud]} descripcion={[trackDescription]} icon={[trackFotos]} info={[trackInfo]} />
                {/* <div className="carousel-demo2">
                                <Carousel value={trackFotos} numVisible={1} numScroll={1} itemTemplate={itemTemplate} header={header} className="custom-carousel" />
                            </div> */}
              </>
              :
              <>
                <label className='font-bold' style={labelStyle} htmlFor="label">Ingreso:</label>
                <span className='font-bold'>Fecha: </span>
                <span>{trackInfo.DATE_IN} </span>
                <span className='font-bold'>Hora: </span>
                <span>{trackInfo.TIME_IN} </span><br />
                <label className='font-bold' style={labelStyle} htmlFor="label">Salida:</label>
                <span className='font-bold'>Fecha: </span>
                <span>{trackInfo.DATE_OUT} </span>
                <span className='font-bold'>Hora: </span>
                <span>{trackInfo.TIME_OUT}</span><br /><br />
                <Button label='Ver ubicación' icon='pi pi-eye' size='small' onClick={showModalMapa} /><br /><br />
                {trackFotos[0] && trackFotos[0].DETAIL && trackFotos[0].DETAIL.length > 0 &&
                  <div>
                    <Galleria value={trackFotos[0].DETAIL} responsiveOptions={responsiveOptions} numVisible={5} style={{ maxWidth: '640px' }}
                      item={itemTemplate} thumbnail={thumbnailTemplate} />
                  </div>}
              </>
        }
      </Dialog>
      <Dialog visible={isOpenMapa} draggable={false} resizable={false} modal onHide={hideModalMapa} style={{ width: width > 768 ? "70vw" : "95vw" , height: "90vh" }}>
        <Maps2 latitud={latitud} longitud={longitud} descripcion={[]} icon={trackFotos} info={[trackInfo]} />
      </Dialog>
      {/* <div className="surface-100 px-4 py-5 md:px-6 lg:px-8"> */}
      <div className="mt-6">
        <SkeletonTable load={loadPage}>
          <Toolbar className='card flex flex-row' start={leftToolbarTemplate} />
          <DataTable className="card text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
            selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="CONTRACT_ID"
            size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['REQUESTS_ID', 'NOVELTY', 'CONTRACT_ID', 'CONTRACT',
              'START_DATE', 'UNITY', 'END_DATE', 'TYPE', 'TIME', 'STATUS']}
            header={header1}>
            <Column field="REQUESTS_ID" header="Id solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por id" sortable></Column>
            <Column field="NOVELTY" header="Tipo solicitud" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
            <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo" sortable></Column>
            <Column field="CONTRACT" header="Nombre" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
            <Column field="START_DATE" header="Feha inicio" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
            <Column field="UNITY" header="Dias" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por días" sortable></Column>
            <Column field="END_DATE" header="Feha fin" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
            <Column field="TYPE" header="Marcación" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por marcación" sortable></Column>
            <Column field="TIME" header="Hora" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por hora" sortable></Column>
            <Column field="STATUS" header="Estado" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
            <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
          </DataTable>
        </SkeletonTable>
      </div>
      {/* </div> */}
    </div>
  );
}

export default Licenses
